import { createFileRoute } from '@tanstack/react-router'

import { validateETicketSearch } from '#pages/ETickets/helpers'

export const Route = createFileRoute('/_authenticated/companies_/$companyId/e-tickets')({
  validateSearch: validateETicketSearch,
})
